import destroy from "../destroy";
import staticInit from "../Main/static/static-init";


/**
 * Initializes a new instance of Group.
 * @class Group
 * @namespace Group.prototype
 * @returns {MainClassProps}
 */
class Group {
  /**
   * @constructor
   * @param {TorusElement} element
   */
  constructor(element) {
    this.element = element;
    this.isGroup = true;
    this.isMain = false;
  }

  /**
   * Initialize the Group class
   * @param {Object} [options]
   */
  init(options) {}

  /**
   * ------------------------------------------------------------------------
   * Static
   * ------------------------------------------------------------------------
   */

  /**
   * Destroy method
   * @param {IterableElementsProps} elements
   */
  static destroy(elements) {
    destroy(elements);
  }

  /**
   * Group init
   * @param {Set<TorusElement> | Array<TorusElement> | null} [elements]
   * @param {Object | null} [options]
   * @returns {Array<MainClassProps>}
   */
  static init(elements = null, options = null) {
    return staticInit("Group", Group, elements, options, "tor-group");
  }
}

export default Group;
